<!-- <div >{{preview}}</div> -->

<div class="preview-container">

    <button mat-mini-fab color="accent" class="cancel-btn" aria-label="cancel-button" [routerLink]="['/features/reports/invoices/edit-invoice',invoiceId]">
                <mat-icon>west</mat-icon>
            </button>
    <pdf-viewer [src]="dataLocalUrl" class="my-3"
                  [original-size]="false"
      ></pdf-viewer>
</div> 